import moment from "moment";
import "moment/locale/th";
var dd = moment.locale("th");
export const ConvertDateShort = (date, format,language = "th") => {
    return moment(date).locale(language).format(format);
};
